import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Zoom } from 'swiper/modules';

export default function initGalleryLightbox(scrollEnabled) {
    const galleries = document.querySelectorAll('.wp-block-gallery');
    if (!galleries.length || !window.HTMLDialogElement) return;

    const dialog = document.createElement('dialog');
    dialog.className = 'gallery-lightbox';
    dialog.setAttribute('aria-label', 'Galerie photos');
    dialog.innerHTML = '<button class="gallery-lightbox__close" type="button" autofocus aria-label="Fermer la galerie">×</button><div class="swiper"><div class="swiper-wrapper"></div></div><button class="gallery-lightbox__prev" type="button" aria-label="Image précédente">←</button><button class="gallery-lightbox__next" type="button" aria-label="Image suivante">→</button><div class="gallery-lightbox__count" aria-live="polite"></div>';
    document.body.append(dialog);
    const wrapper = dialog.querySelector('.swiper-wrapper');
    let swiper;
    let trigger;

    function open(gallery, selected, source) {
        trigger = source;
        const images = Array.from(gallery.querySelectorAll('img'));
        wrapper.replaceChildren();
        images.forEach((original) => {
            const slide = document.createElement('figure');
            slide.className = 'swiper-slide';
            const zoom = document.createElement('div');
            zoom.className = 'swiper-zoom-container';
            const picture = document.createElement('img');
            const link = original.closest('a');
            const mediaLink = link && /\.(?:jpe?g|png|gif|webp|avif|svg)(?:[?#]|$)/i.test(link.href);
            picture.src = original.dataset.fullUrl || original.dataset.origFile || (mediaLink ? link.href : original.currentSrc || original.src);
            picture.alt = original.alt || '';
            picture.loading = original === selected ? 'eager' : 'lazy';
            zoom.append(picture);
            slide.append(zoom);
            const caption = original.closest('figure')?.querySelector('figcaption')?.textContent.trim();
            if (caption) {
                const text = document.createElement('figcaption');
                text.textContent = caption;
                slide.append(text);
            }
            wrapper.append(slide);
        });
        dialog.showModal();
        scrollEnabled(false);
        swiper = new Swiper(dialog.querySelector('.swiper'), {
            modules: [Navigation, Pagination, A11y, Zoom],
            initialSlide: images.indexOf(selected),
            rewind: true,
            zoom: true,
            navigation: {
                prevEl: dialog.querySelector('.gallery-lightbox__prev'),
                nextEl: dialog.querySelector('.gallery-lightbox__next'),
            },
            pagination: { el: dialog.querySelector('.gallery-lightbox__count'), type: 'fraction' },
            a11y: {
                prevSlideMessage: 'Image précédente',
                nextSlideMessage: 'Image suivante',
                slideLabelMessage: 'Image {{index}} sur {{slidesLength}}',
            },
        });
    }

    galleries.forEach((gallery) => {
        // Un seul lecteur, même si « Agrandir au clic » est activé dans WordPress.
        gallery.querySelectorAll('.lightbox-trigger').forEach((button) => { button.hidden = true; });
        gallery.querySelectorAll('img').forEach((picture) => {
            const control = picture.closest('a') || picture;
            control.setAttribute('aria-haspopup', 'dialog');
            if (control === picture) {
                picture.tabIndex = 0;
                picture.setAttribute('role', 'button');
                picture.setAttribute('aria-label', picture.alt ? `Agrandir : ${picture.alt}` : 'Agrandir l’image');
            }
        });
        const activate = (event) => {
            const control = event.target.closest('a, img');
            const picture = control?.matches('img') ? control : control?.querySelector('img');
            if (!picture || !gallery.contains(picture)) return;
            if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
            if (event.type === 'click' && (event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            open(gallery, picture, control);
        };
        gallery.addEventListener('click', activate, true);
        gallery.addEventListener('keydown', activate, true);
    });
    dialog.querySelector('.gallery-lightbox__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            event.key === 'ArrowLeft' ? swiper.slidePrev() : swiper.slideNext();
        }
    });
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
        swiper?.destroy(true, true);
        wrapper.replaceChildren();
        scrollEnabled(true);
        if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    });
}
